import {
  hideLoaderDomUtil,
  showLoaderDomUtil
} from 'client/utils/dom'
import { getHeadersAndEndpointApiUtil } from 'modules/api/utils'
import fetchNetworkUtil from 'modules/training/modules/network/utils/fetch'

async function postApiService (endpointParam, data, {
  timeoutMs,
  ...options
} = {}) {
  if (BROWSER) {
    showLoaderDomUtil()
  }

  const {
    headers,
    endpoint
  } = getHeadersAndEndpointApiUtil(endpointParam, options)
  const response = await fetchNetworkUtil(endpoint, {
    credentials: 'include',
    headers,
    method: 'POST',
    body: JSON.stringify(data)
  })

  const json = await response.json()

  if (response.ok && BROWSER) {
    hideLoaderDomUtil()
  }

  if (response.ok) {
    return json
  }

  if (BROWSER) {
    hideLoaderDomUtil()
  }
  throw json
}

export default postApiService
